import * as Yup from "yup";

import { validateEmail } from "utils/validators";

import { countries } from "../countriesHelper";

const getPhoneRegex = (ddi) => {
  const country = countries.find((country) => country.prefix === ddi);
  return country?.pattern?.regex || countries[0].pattern.regex;
};

export const initialLoginForm = {
  name: "",
  email: "",
  ddi: "BRA",
  phone: "",
  businessName: "",
};

export const loginSchema = Yup.object({
  ddi: Yup.string().required("Selecione o DDI."),
  phone: Yup.string()
    .required("Telefone é obrigatório")
    .test("is-valid-phone", "Telefone inválido.", function (value) {
      const { ddi } = this.parent;
      const regex = getPhoneRegex(ddi);
      return regex.test(value);
    }),
});

export const newBusinessSchema = Yup.object({
  name: Yup.string().required("Nome é obrigatório"),
  email: Yup.string()
    .notRequired()
    .test("email", "E-mail inválido", (value) => {
      if (!value || value.trim() === '') return true;
      return validateEmail(value);
    }),
  ddi: Yup.string().required("Selecione o DDI."),
  phone: Yup.string()
    .required("Telefone é obrigatório")
    .test("is-valid-phone", "Telefone inválido.", function (value) {
      const { ddi } = this.parent;
      const regex = getPhoneRegex(ddi);
      return regex.test(value);
    }),
  businessName: Yup.string().required("Nome do negócio é obrigatório"),
});
